import React, { useId } from 'react';
export { useBusinessAction } from './useBusinessAction';

export function Notice({ error, children }) {
  return <div role={error ? 'alert' : 'status'} className={`gb-notice${error ? ' gb-error' : ''}`}>{error && <span className="gb-notice-mark" aria-hidden="true">!</span>}{children}</div>;
}
export function Action({ primary, quiet, className = '', children, ...props }) {
  return <button type="button" className={[primary ? 'gb-primary' : quiet ? 'gb-quiet' : '', className].filter(Boolean).join(' ')} {...props}>{children}</button>;
}
export function Field({ label, children, hint }) {
  const id = useId();
  const control = React.cloneElement(children, {
    'aria-labelledby': children.props['aria-labelledby'] || (children.props['aria-label'] ? undefined : `${id}-label`),
    'aria-describedby': [children.props['aria-describedby'], hint && `${id}-hint`].filter(Boolean).join(' ') || undefined,
  });
  return <label><span id={`${id}-label`}>{label}</span>{control}{hint && <small id={`${id}-hint`}>{hint}</small>}</label>;
}
export function ListState({ resource, empty = 'Nothing here yet.' }) {
  return <>{resource.error && <Notice error>{resource.error.message} <Action onClick={resource.refresh}>Retry</Action></Notice>}
    {resource.loading && <p role="status">Loading…</p>}
    {!resource.loading && !resource.error && !resource.items.length && <p className="gb-muted">{empty}</p>}
    {resource.next && <Action disabled={resource.loading} onClick={resource.more}>Load more</Action>}</>;
}
export function ActionState({ action }) { return <>{action.error && <Notice error>{action.error}</Notice>}{action.message && <Notice>{action.message}</Notice>}</>; }
